// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-bfa96222] .newdoctor .vs__dropdown-toggle,[data-v-bfa96222] .stateto .vs__dropdown-toggle {\n  padding: 0 !important;\n  height: auto;\n}\n", ""]);
// Exports
module.exports = exports;
